import SuccessIcon from '@groovepages/gd-ui-kit/assets/check-circle.svg?fileloader';
import CloseIcon from '@groovepages/gd-ui-kit/assets/close-icon1.svg?fileloader';
import ErrorIcon from '@groovepages/gd-ui-kit/assets/error-circle.svg?fileloader';

export default {
  render(title, text, color, icon, time = 5000, position) {
    const container = document.createElement('div');
    container.classList.add(
      'p-4',
      'fixed',
      'z-50',
      'flex',
      'flex-row',
      'justify-between',
      'rounded',
      'shadow-lg',
      color
    );
    if(position == 'bottom-right') {
      container.style.right = '1rem';
      container.style.bottom = '1rem';
    } else if(position == 'top-right') {
      container.style.right = '1rem';
      container.style.top = '1rem';
    } else if(position == 'top-left') {
      container.style.left = '1rem';
      container.style.top = '1rem';
    } else {
      container.style.left = '1rem';
      container.style.bottom = '1rem';
    }
    container.style.width = '360px';
    container.innerHTML = `
    <div class="h-full mr-3 mt-1">
      <img class="h-4" src="${icon}">
    </div>
    <div class="flex-grow flex-col text-white">
      <div class="">${title}</div>
      <div class="text-sm">${text}</div>
    </div>
    <div class="close h-full mt-1 cursor-pointer">
      <img class="h-4" src="${CloseIcon}">
    </div>`;
    container.querySelectorAll('.close')[0].addEventListener('click', () => {
      container.remove();
    });
    document.body.appendChild(container);
    setTimeout(() => {
      container.remove();
    }, time);
    return container;
  },
  success(title, position, text = '', time) {
    return this.render(title, text, 'bg-green', SuccessIcon, time, position);
  },
  fail(title, position, text = '', time) {
    return this.render(title, text, 'bg-pink-dark', ErrorIcon, time, position);
  },
  warn(title, position, text = '', time) {
    return this.render(title, text, 'bg-yellow', SuccessIcon, time, position);
  }
};
